<template>
    <common-table :table-columns="tableColumns"
                  :url="url" :operate="[]"
                  :form-fields="{toTree: false, model: []}"
                  :permission="[]"
                  :searchs="searchs"
                  ref="table"
    />
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "UserLevel",
        components: {CommonTable},
        data() {
            return {
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectValue: []
                    },
                    {
                        name: 'phone',
                        placeholder: '手机号',
                        type: 'input'
                    },

                    {
                        name: 'inviteCode',
                        placeholder: '邀请码',
                        type: 'input'
                    },
                ],
                url: {
                    get: '/userInfo/level/all',
                },
                tableColumns: [{
                    field: 'count',
                    label: '人数',
                    show: true,
                    width: '',
                }, {
                    field: 'rechargeAmount',
                    label: '总充值(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalAmount',
                    label: '总提现(USDT)',
                    show: true,
                    width: '',
                }]
            }
        }
    }
</script>

<style scoped>

</style>
